// Styles — Parcel will extract these into a CSS bundle
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

import $ from 'jquery';
import 'popper.js';
import 'bootstrap';
import registerHerbyCookie from './herbyCookie';
import slugRedirection from './reroute';
import decideSiteVersion from './decideSiteVersion';
import intercomLoader from './intercomLoader';

slugRedirection();
decideSiteVersion();
intercomLoader();

// Make jQuery available globally for inline scripts and future plugins
window.$ = $;
window.jQuery = $;

const contactFormSubmitUrl = process.env.CONTACT_FORM_SUBMIT_URL;

registerHerbyCookie($);

$(document).ready(function () {
  // Mobile submenu toggle
  $(document).on('click', '.submenu-toggle-btn', function (e) {
    e.preventDefault();
    e.stopPropagation();
    const $submenu = $(this).closest('.dropdown-submenu');
    const isOpen = $submenu.hasClass('submenu-open');
    $submenu.toggleClass('submenu-open', !isOpen);
    $(this).attr('aria-expanded', String(!isOpen));
  });

  $(document).herbyCookie({
    heading: 'We use cookies',
    text: 'We use cookies to ensure you get the best experience on our website. By continuing to browse, you agree to our',
    policyText: 'Privacy Policy',
    link: 'https://policies.swirepay.com/',
    btnText: 'Accept All',
    expireDays: 30,
    scroll: false,
  });
});

window.registerWithEmail = function (inputFieldId) {
  if (!inputFieldId) {
    return;
  };
  const email = $(`#${inputFieldId}`).val();
  if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    $(`#${inputFieldId}-error-msg`).text('Please enter valid E-mail to proceed.');
    return;
  }
  window.location.href = `https://${process.env.FRONTEND_URL}/register?email=${email}`;
}

window.submitContactInfo = function() {
  const $submitBtn = $('.contact-form-section__submit');
  if ($submitBtn.prop('disabled')) return;

  const name = $('#contactName').val().trim();
  const email = $('#contactEmail').val().trim();
  const phone = $('#contactPhone').val().trim();
  const message = $('#contactMessage').val().trim();

  // loading spinner
  const $spinner = $('<span>').addClass('ml-2 spinner spinner--white').attr('id', 'contactUsSubmitSpinner');
  $submitBtn.prop('disabled', true).append($spinner);
  
  let isValid = true;

  // Name: 2–100 chars, letters/spaces/hyphens/apostrophes only
  if (!name) {
    $('#contactName-error-msg').text('Name is required.');
    isValid = false;
  } else if (name.length < 2) {
    $('#contactName-error-msg').text('Name must be at least 2 characters.');
    isValid = false;
  } else if (name.length > 100) {
    $('#contactName-error-msg').text('Name must not exceed 100 characters.');
    isValid = false;
  } else if (!/^[a-zA-Z\s'\-]+$/.test(name)) {
    $('#contactName-error-msg').text('Name may only contain letters, spaces, hyphens, and apostrophes.');
    isValid = false;
  } else {
    $('#contactName-error-msg').text('');
  }

  // Email: 5–254 chars, valid format
  if (!email) {
    $('#contactEmail-error-msg').text('Email is required.');
    isValid = false;
  } else if (email.length < 5) {
    $('#contactEmail-error-msg').text('Email must be at least 5 characters.');
    isValid = false;
  } else if (email.length > 254) {
    $('#contactEmail-error-msg').text('Email must not exceed 254 characters.');
    isValid = false;
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    $('#contactEmail-error-msg').text('Enter a valid email address (e.g. name@example.com).');
    isValid = false;
  } else {
    $('#contactEmail-error-msg').text('');
  }

  // Phone: must start with + country code, 7–15 digits total
  if (!phone) {
    $('#contactPhone-error-msg').text('Phone number is required.');
    isValid = false;
  } else if (!/^\+/.test(phone)) {
    $('#contactPhone-error-msg').text('Phone must include a country calling code (e.g. +1 for US, +91 for India).');
    isValid = false;
  } else if (!/^\+[1-9]\d{6,14}$/.test(phone.replace(/[\s\-().]/g, ''))) {
    $('#contactPhone-error-msg').text('Enter a valid phone number with country code (e.g. +14155552671).');
    isValid = false;
  } else {
    $('#contactPhone-error-msg').text('');
  }

  // Message: 10–1000 chars
  if (!message) {
    $('#contactMessage-error-msg').text('Message is required.');
    isValid = false;
  } else if (message.length < 5) {
    $('#contactMessage-error-msg').text('Message must be at least 5 characters.');
    isValid = false;
  } else if (message.length > 1000) {
    $('#contactMessage-error-msg').text('Message must not exceed 1000 characters.');
    isValid = false;
  } else {
    $('#contactMessage-error-msg').text('');
  }

  if (!isValid) {
    $submitBtn.prop('disabled', false).text('Submit');
    return;
  }

  // Form submission
  const payload = {
    payloadType: 'SWIREPAY_MAIN_CONTACT_FORM',
    name,
    email,
    phone,
    message,
  };

  fetch(contactFormSubmitUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  }).then(res => {
    if (!res.ok) throw new Error('Could Not Submit');
    const $lucideTickMarkIcon = $('<i>').attr('data-lucide', 'check').addClass('ml-2').attr('style', 'color: #22c55e; width: 38px; height: 38px');
    $submitBtn.text('Submitted').append($lucideTickMarkIcon);
    lucide.createIcons();
  }).catch(err => {
    const $lucideCrossIcon = $('<i>').attr('data-lucide', 'x').addClass('ml-2').attr('style', 'color: #ef4444; width: 38px; height: 38px');
    $submitBtn.text('Submit Failed').append($lucideCrossIcon);
    lucide.createIcons();
  }).finally(() => {
    setTimeout(() => {
      $submitBtn.prop('disabled', false).text('Submit');
    }, 5000);
  });
}
